module.exports = __webpack_public_path__ + "src/assets/img/open-act-btn.11de2f78.png";